module.exports = __webpack_public_path__ + "assets/img/plant-2.78144d95.png";